export async function attachLicenseAttributes(components, fetchLicenseAttributes) {
  const missingIdentifiers = [
    ...new Set(
      components
        .filter((component) => !component.licenseAttribute && component.licenseIdentifier)
        .map((component) => component.licenseIdentifier),
    ),
  ];

  const attributeByIdentifier = new Map();

  if (missingIdentifiers.length > 0) {
    const licenseAttributes = await fetchLicenseAttributes({ ids: missingIdentifiers });
    if (Array.isArray(licenseAttributes)) {
      licenseAttributes.forEach((licenseAttribute) => {
        if (licenseAttribute?.licenseIdentifier) {
          attributeByIdentifier.set(licenseAttribute.licenseIdentifier, licenseAttribute);
        }
      });
    }
  }

  return components.map((component) => {
    if (component.licenseAttribute || !component.licenseIdentifier) {
      return component;
    }

    return {
      ...component,
      licenseAttribute: attributeByIdentifier.get(component.licenseIdentifier) ?? null,
    };
  });
}
